import { Component, input, OnInit } from '@angular/core';
import { AssessmentInfoComponent } from '../assessment-info/assessment-info.component';
import { AssessmentRowComponent } from '../../assessments-tab/assessment-row/assessment-row.component';
import { HEENTAssessment } from 'src/app/calvin-emr-shared/models/assessments/HEENT.model';

import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';

@Component({
  selector: 'app-heent-info',
  templateUrl: './heent-info.component.html',
  styleUrls: ['./heent-info.component.scss'],
  standalone: true,
  imports: [AssessmentRowComponent],
})
export class HEENTInfoComponent
  extends AssessmentInfoComponent<HEENTAssessment>
  implements OnInit {

  patient = input.required<Patient>();

  ngOnInit(): void { }

  get isScleraYellow() {
    return this.data().scleraYellow ? 'Yes' : 'No';
  }

  get isConjunctivaPale() {
    return this.data().conjunctivaPale ? 'Yes' : 'No';
  }

  get isConjunctivaRed() {
    return this.data().conjunctivaRed ? 'Yes' : 'No';
  }

  get isAsymmetrical() {
    return this.data().earsAsymmetrical ? 'Yes' : 'No';
  }

  get isHearingAidLeft() {
    return this.data().hearingAidLeft ? 'Yes' : 'No';
  }

  get isHearingAidRight() {
    return this.data().hearingAidRight ? 'Yes' : 'No';
  }

  get hasDryMucusMembranes() {
    return this.data().throatDryMucusMembranes ? 'Yes' : 'No';
  }
}